import { render, staticRenderFns } from "./AddNewsSource.vue?vue&type=template&id=d43215fe&scoped=true&"
import script from "./AddNewsSource.vue?vue&type=script&lang=js&"
export * from "./AddNewsSource.vue?vue&type=script&lang=js&"
import style0 from "./AddNewsSource.vue?vue&type=style&index=0&id=d43215fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d43215fe",
  null
  
)

export default component.exports